import type { HTMLAttributes, ReactElement } from 'react';

import { classNames } from '@m1work/shared-utils';

import styles from './Card.module.scss';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {}

/**
 * A white rounded panel with large padding, e.g. a form or a modal body.
 *
 * @example
 * <Card>{form}</Card>
 */
export function Card({ className, children, ...props }: CardProps): ReactElement {
    return (
        <div className={classNames(styles.card, className)} {...props}>
            {children}
        </div>
    );
}
